import { useEffect } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { scrollToTab, TabName } from '../utils/tab-names';

export const useScrollToTabByQueryParam = (offset = 0) => {
    const { queryParameters } = getContext();
    const { tabId } = queryParameters;

    useEffect(() => {
        const relevantTabId = Object.keys(TabName).find(
            (key) => TabName[key].toLowerCase() === (tabId as string)?.toLowerCase?.()
        );

        if (relevantTabId) {
            setTimeout(() => {
                scrollToTab(TabName[relevantTabId], offset);
            }, 200);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
